module.exports = __webpack_public_path__ + "img/mtt_1.4.e41c3eea.png";